import { render, staticRenderFns } from "./TruncatedText.vue?vue&type=template&id=544f69fe&scoped=true&"
import script from "./TruncatedText.vue?vue&type=script&lang=js&"
export * from "./TruncatedText.vue?vue&type=script&lang=js&"
import style0 from "./TruncatedText.vue?vue&type=style&index=0&id=544f69fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544f69fe",
  null
  
)

export default component.exports